import { multiDayAllDayFormatString } from 'owa-locstrings/lib/strings/multidayalldayformatstring.locstring.json';
import loc, { format } from 'owa-localize';

import { DateRangeType, ViewSetting, WorkWeekViewSettings } from '..';

import { formatUserDate, formatWeekDayMonthDayYear, formatYearMonth } from 'owa-datetime';
import { getVisibleDateRange } from './getVisibleDateRange';

export function formatPrintRange(viewSettings: ViewSetting & WorkWeekViewSettings) {
    const { start, end } = getVisibleDateRange(viewSettings);

    switch (viewSettings.view) {
        case DateRangeType.Day:
            return formatWeekDayMonthDayYear(start);
        case DateRangeType.Month:
            return formatYearMonth(start);
        default:
            return format(
                loc(multiDayAllDayFormatString),
                formatUserDate(start),
                formatUserDate(end)
            );
    }
}
